<template>
    <div class="mypolicydetial">
        <div class="content">
            <ul class="tab_box" v-if="tabList.length > 1" :style="tabList.length < 3 ? 'justify-content: space-around;' : 'justify-content: space-between;'">
                <li v-for="(item, index) in tabList" :key="index" @click="changeTab(item, index)">
                    <span :class="tabActiveIndex == item.value ? 'active' : 'not_active'">{{item.text}}</span>
                    <img src="../../../assets/image/nsale/tabSelected.png" alt="" v-if="tabActiveIndex == item.value">
                    <p class="empty_line" v-else></p>
                </li>
            </ul>
            <!-- 原始保单 -->
            <div class="policy" v-show="tabActiveIndex=='1'">
                <ul>
                    <li class="product">
                        <span class="title">{{policyInfo.proName}}</span>
                        <span class="red" v-if="policyInfo.proLarge=='长期险'">{{policyInfo.visitStatus || '待回访'}}</span>
                    </li>
                    <li>保单号：{{dealNull(policyInfo.pno)}}</li>
                    <li>保单起期：{{filterDate(policyInfo.effectiveDate)}}</li>
                    <li>保单止期：{{filterDate(policyInfo.expireDate)}}</li>
                    <li>等待期：{{dealNull(policyInfo.wait)}}</li>
                    <li>保障额度：{{dealNull(policyInfo.insuredAmt, '元')}}</li>
                    <li>交费年限：{{dealNull(policyInfo.payPeriod, '年')}}</li>
                    <li>犹豫期：{{dealNull(policyInfo.hesitate, '天')}}</li>
                    <li>保障年限：{{filterNumber(policyInfo.guaranteePeriod)}}</li>
                    <li>
                        保单状态：{{dealNull(policyInfo.status)}}
                        <a class="download-file" v-if="policyInfo.status&&(policyInfo.status.indexOf('问题件')||policyInfo.status == '6')>-1&&questionList && questionList.length==1" :href="questionList[0].url" :download="questionList[0].fileName">{{questionList[0].fileName}}</a>
                        <span class="download-btn" v-if="policyInfo.status&&(policyInfo.status.indexOf('问题件')||policyInfo.status == '6')&&questionList && questionList.length > 1" @click="showQuestionList=true">问题件下载</span>
                    </li>
                    <li>{{policyInfo.visit_status?'保费：':'首次保费：'}}{{dealNull(policyInfo.premium, '元')}}</li>
                    <li v-if="dealNull(policyInfo.agentCommission) != '-'">{{cooperationMode == 1 ? '积分：': '宣传奖励：'}}{{dealNull(policyInfo.agentCommission, '元')}}</li>
                    <li>付款时间：{{filterDate(policyInfo.arriveAccountDate)}}</li>
                </ul>
                <ul class="policyhoder" v-if="policyInfo.holderInfo">
                    <li class="title">投保人信息</li>
                    <li>姓名：{{dealNull(policyInfo.holderInfo.inName)}}</li>
                    <li v-if="policyInfo.holderInfo.type!='C'">证件类型：{{filterStatus(policyInfo.holderInfo.idType, idTypeOptions)}}</li>
                    <li v-else>证件类型：{{filterStatus(policyInfo.holderInfo.idType, companyIdTypeOptions)}}</li>
                    <li>证件号：{{dealNull(policyInfo.holderInfo.idNum)}}</li>
                    <li>手机号：{{dealNull(policyInfo.holderInfo.mobile)}}</li>
                    <li>邮箱：{{dealNull(policyInfo.holderInfo.email)}}</li>
                    <li>地址：{{dealNull(policyInfo.holderInfo.add)}}</li>
                    <li v-if="policyInfo.visit_status">续费开户行：{{policyInfo.holderInfo.bankN}}</li>
                    <li v-if="policyInfo.visit_status">续费银行卡：{{policyInfo.holderInfo.bankCard}}</li>
                </ul>
                <div v-if="policyInfo.insuredInfo && policyInfo.insuredInfo.length > 0">
                    <ul class="insured" v-for="(item, index) in policyInfo.insuredInfo" :key="item.idNum">
                        <li class="title">被保人信息{{index+1}}</li>
                        <li>姓名：{{dealNull(item.inName)}}</li>
                        <li v-if="item.type!='C'">证件类型：{{filterStatus(item.idType, idTypeOptions)}}</li>
                        <li v-else>证件类型：{{filterStatus(item.idType, companyIdTypeOptions)}}</li>
                        <li>证件号：{{dealNull(item.idNum)}}</li>
                        <li>性别：{{dealNull(item.gender)}}</li>
                    </ul>
                </div>
                <ul class="beneficiary">
                    <li class="title">保险金受益人</li>
                    <li>受益人：{{policyInfo.beneficiaryPerson || '法定受益人'}}</li>
                </ul>
                <p v-if="$route.query.electronicInsurance!='N'" class="elec_policy" @click="goPDF()">查看电子保单</p>
                <p v-if="policyInfo.riskStatus==='3' || policyInfo.riskStatus==='1'" class="elec_policy" @click="goRiskDetail()" >查看风险告知函</p>
                <div class="tips">
                    <p>全部产品获取</p>
                    <p>请用电脑360浏览器登录https://nyboss.ssish.com/</p>
                </div>
            </div>
            <!-- 期缴保单 -->
            <div class="periodic_payment" v-show="tabActiveIndex=='2' && periodicPaymentList.length > 0">
                <h3>{{policyInfo.proName}}</h3>
                <ul v-for="(item, index) in periodicPaymentList" :key="index">
                    <li>保单号：{{policyInfo.pno}}</li>
                    <li>截至时间：{{filterDate(item.expireDate)}}</li>
                    <li>实际缴费时间：{{filterDate(item.arriveAccountDate)}}</li>
                    <li>保费：{{dealNull(item.premium, '元')}}</li>
                    <li v-if="dealNull(item.agentCommission) != '-'">{{cooperationMode == 1 ? '积分：': '宣传奖励：'}}{{dealNull(item.agentCommission, '元')}}</li>
                </ul>
            </div>
            <!-- 批改保单 -->
            <div class="periodic_payment" v-show="tabActiveIndex=='3' && correctList.length > 0">
                <h3>{{policyInfo.proName}}</h3>
                <ul v-for="(item, index) in correctList" :key="index">
                    <li>批单号：{{item.cno}}</li>
                    <li>时间：{{filterDate(item.effectiveDate)}}</li>
                    <li>保费：{{dealNull(item.premium, '元')}}</li>
                    <li v-if="dealNull(item.agentCommission) != '-'">{{cooperationMode == 1 ? '积分：': '宣传奖励：'}}{{dealNull(item.agentCommission, '元')}}</li>
                </ul>
            </div>
            <!-- 加保保单 -->
            <div class="periodic_payment" v-show="tabActiveIndex=='4' && addPolicyList.length > 0">
                <ul v-for="(item, index) in addPolicyList" :key="index">
                    <li class="title">{{item.productName}}</li>
                    <li>加保时间：{{filterDate(item.addPolicyTime)}}</li>
                    <li>加保保费：{{dealNull(item.amount, '元')}}</li>
                    <li v-if="dealNull(item.commission) != '-'">{{cooperationMode == 1 ? '积分：': '宣传奖励：'}}{{dealNull(item.commission, '元')}}</li>
                </ul>
            </div>
            <!-- 问题件下载 -->
            <div class="mask" v-if="showQuestionList" @click.self="showQuestionList=false">
                <div class="renewal-guide">
                    <h3 class="pro-title">问题件下载</h3>
                    <p class="close_" @click="showQuestionList=false">x</p>
                    <div class="scroll-box">
                        <a v-for="(item, index) in questionList" :key="index" :href="item.url" :download="item.fileName">{{item.fileName}}</a>
                    </div>
                </div>
            </div>
        </div>

        <cube-popup ref="downloadPop" :visible="isShowPopup" position="center" class="download-popup">
            <downloadPolicyPopup :isShow="isShowPopup" :policyDetail="policyDetail" @close="closeDownloadPopup" />
        </cube-popup>
    </div>
</template>
<script>
import api from "@/utils/api";
import commonData from '@/utils/commonoptions';
import downloadPolicyPopup from './components/downloadElcPolicy.vue';
const { idTypeOptions, companyIdTypeOptions }=commonData
document.title = '保单详情'
export default {
    components: {downloadPolicyPopup},
    data() {
        return {
            tabList: [
                {
                    text: '原始保单',
                    value: '1'
                },
            ],
            showQuestionList: false, // 问题件下载弹框
            questionList: [], // 问题件列表
            tabActiveIndex: '1',
            policyInfo: {
                proName: '测试数据测试数据'
            },
            idTypeOptions,
            companyIdTypeOptions,
            cooperationMode: 1, //合作模式 1-经代模式 2-互联网模式
            periodicPaymentList: [], // 期缴保单列表
            correctList: [], // 批改保单列表 
            addPolicyList: [], // 加保保单
            isShowPopup: false, // 是否显示下载电子保单弹框
            policyDetail: {}, // 保单详情
        }
    },
    created() {
        this.fetchPolicyInfo();
    },
    methods:{
        // 关闭获取验证码弹窗
        closeDownloadPopup(item) {
            this.isShowPopup = false;
            if(item) {
                this.goPDF(item, true);
            }
        },
        // 判断当前点击产品签约结构是否属于信美人生
        showDownloadPopup(productCode) {
            return new Promise((resolve, reject) => {
                api.isXinMeiPro(productCode).then((res)=>{
                    var result = res.data;
                    if(result.returnCode=='0000'){
                        let isXinMei = result.data === '信美人生相互保险社' || result.data === ' 信美人寿相互保险社';
                        resolve(isXinMei);
                    }
                }).catch(() => {
                })
            })
        },
        // 处理null
        dealNull(val, unit='') {
            if(!val) return '-'
            if(val=='null'||val=='undefined'){
                return '-'
            }
            return `${val}${unit}`
        },
        // 处理时间格式
        filterDate(val) {
            if(!val) return '-'
            if(val=='null'||val=='undefined'){
                return '-'
            }
            if(val.indexOf('-') < 0 && val.indexOf('/') < 0) {
                return val;
            }
            let dateArr = [];
            if (val.indexOf('-') > -1) {
                dateArr = val.split('-');
            } else if (val.indexOf('/') > -1) {
                dateArr = val.split('/');
            }
            return `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
        },
        filterStatus:(val,options)=>{
            if(!val){
                return '-'
            }else{
                let name = '-'
                for(let i = 0; i < options.length; i++) {
                if (options[i].value === val || options[i].text === val) {
                    name = options[i].text;
                    break;
                }
                }
                return name;
            }
        },
        filterNumber:(val)=>{
            if(!val){
                return '-'
            } else {
                if(!/^\d+$/.test(val)){
                    return val
                }else if (val < 60){
                    return val+'年'
                } else if (val>=60 && val < 100) {
                    return '保至'+val+'岁'
                } else {
                    return '终身'
                }
            }
        },
        // 切换Tab
        changeTab(item) {
            this.tabActiveIndex = item.value;
        },
        // 查看电子保单
        async goPDF(isSendCode){
            // 如果没有验证码
            if(!isSendCode) {
                // 判断签约机构是否为信美人生
                let isXinMei = await this.showDownloadPopup(this.policyInfo.proCode);
                // 如果是信美人生，则弹出获取验证码弹窗
                if(isXinMei) {
                    this.isShowPopup = true;
                    this.policyDetail = this.policyInfo.holderInfo;
                    return;
                }
            }

            if(this.policyInfo.epolicyUrl && this.policyInfo.epolicyUrl.indexOf('http') > -1){
                window.location.href = this.policyInfo.epolicyUrl
            }else{
                window.$toast("此电子保单请前往电脑端登陆yutai365.com下载");
            }
        },
        // 查询问题件列表
        getQuestionList() {
            api.questionList({policyId: this.policyInfo.policyId}).then((res) => {
                console.log(res)
                let { returnCode, returnMsg, content } = res.data;
                if(returnCode != '0000') {
                this.$toast(returnMsg);
                return;
                }
                this.questionList = content
            })
        },
        // 查询保单信息
        fetchPolicyInfo() {
            api.getPolicyBysfid({sfid: this.$route.query.proSfid, userId: this.$route.query.userId}).then((res) => {
                let { returnCode, returnMsg, content } = res.data;
                if (returnCode !== '0000') {
                    window.$toast(returnMsg);
                    return;
                }
                if (content) {
                    this.cooperationMode = content.cooperationMode
                    this.policyInfo  = content;
                    if(this.policyInfo.status.indexOf('问题件') > -1 || this.policyInfo.status == '6') {
                        this.getQuestionList();
                    }
                    if (content.policyRel && content.policyRel.length) {
                        this.tabList = [{text: '原始保单', value: '1'}];
                        this.periodicPaymentList = content.policyRel.filter(item1 => !item1.cno && item1.type !== "加保");
                        if(this.periodicPaymentList.length > 0) {
                            this.tabList.push({
                                text: '期缴保单',
                                value: '2'
                            })
                        }
                        this.correctList = content.policyRel.filter(item1 => item1.cno && item1.type !== "加保");
                        if(this.correctList.length > 0) {
                            this.tabList.push({
                                text: '批改保单',
                                value: '3'
                            })
                        }
                        this.fetchAddPolicyList();
                    }
                }
            })
        },
        // 查询加保保单信息
        fetchAddPolicyList() {
            api.policyAddRecond({policyNo: this.policyInfo.pno}).then((res) => {
                let {returnCode, content} = res.data
                if(returnCode == '0000'){
                    this.addPolicyList = content
                    if(this.addPolicyList.length > 0) {
                        this.tabList.push({
                            text: '加保保单',
                            value: '4'
                        })
                    }
                } else {
                    // window.$toast(returnMsg)
                }
            })
        },

        // 打开风险告知函详情页
        goRiskDetail() {
            this.$router.push({
            path: '/bs/risk-detail',
            query: { no: this.policyInfo.pno }
        })
    },
    }
}
</script>
<style lang="scss" scoped>
    .mypolicydetial {
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        background: #fff;
        min-width: 100vw;
        min-height: 100vh;
        padding: 10px 18px;
        box-sizing: border-box;
        .mask {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: rgba(0, 0, 0, 0.45);
            font-size: 12px;
            .renewal-guide {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100vw;
            height: 40%;
            background: #fff;
            border-radius: 20px 20px 0 0;
            padding: 20px;
            box-sizing: border-box;
            }
            .pro-title {
            font-size: 13px;
            color: #373737;
            font-weight: bold;
            margin-bottom: 14px;
            }
            .close_ {
            position: absolute;
            right: 20px;
            top: 20px;
            color: #000;
            font-size: 16px;
            text-align: right;
            }
            .scroll-box {
                max-height: 80%;
                overflow: auto;
                padding: 10px;
                 a {
                    display: block;
                    color:#5599FF;
                    text-decoration: underline;
                    line-height: 2.2;
                    text-align: left;
                }
            }
        }
        .tab_box {
            width: 100%;
            display: flex;
            font-size: 13px;
            color: #333333;
            li {
                height: 44px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                padding-bottom: 9px;
                box-sizing: border-box;
                .active {
                    font-size: 15px;
                    font-weight: bold;
                    margin-bottom: 4px;
                }
                .not_active {
                    margin-bottom: 6px;
                }
                .empty_line {
                    height: 6px;
                }
                img {
                    width: 19px;
                }
            }
        }
        .policy {
            background: #F9F9F9;
            padding: 16px 18px;
            box-sizing: border-box;
            border-radius: 7px;
            .product {
                .red {
                    line-height: 21px;
                    color: #FF7C6D;
                    font-size: 13px;
                    vertical-align: bottom;
                }
            }
            .download-file {
                color: #5599FF; 
                text-decoration: underline;
                margin-left: 10px;
                max-width: 50%;
            }
             .download-btn {
                color: #5599FF; 
                margin-left: 10px;
            }
            .title {
                font-size: 15px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 21px;
                max-width: 250px;
            }
            ul {
                margin-bottom: 15px;
                padding-bottom: 15px;
                border-bottom: 1px solid #ECECEC;
            }
            li {
                line-height: 17px;
                margin-bottom: 4px;
                font-size: 12px;
                color: #666;
            }
            li:last-child {
                margin-bottom: 0;
            }
            li:first-child {
                margin-bottom: 9px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
            }
            .elec_policy {
               color: #5599FF; 
               text-decoration: underline;
            //    border-bottom: 1px solid #5599FF;
               margin-bottom: 12px;
               margin-right: 12px;
            }
            .tips {
                font-size: 11px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #CACACA;
                p {
                    width: 100%;
                    height: 15px;
                    line-height: 15px;
                    text-align: center;
                }
            }
        }
        .periodic_payment {
            margin-top: 4px;
            h3,
            .title {
                font-size: 15px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 21px;
                margin-bottom: 12px;
            }
            ul {
                background: #F9F9F9;
                border-radius: 7px;
                margin-bottom: 15px;
                padding: 19px 16px;
                li {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 17px;
                    margin-bottom: 4px;
                }
                li:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
<style lang="scss">
.download-popup .cube-popup-center .cube-popup-content {
    top: -50% !important;
}
</style>